import { fromJS } from 'immutable';
import get from 'lodash/get';
import { AssignmentAction } from 'containers/CourtManagerAssignedClaims/typings';
import {
  SET_LAWYER_ASSIGNED_CLAIMS,
  SET_LEGAL_PROCEEDINGS_STEPS,
} from 'containers/LawyerAssignmentsPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';
import { SET_SEARCH } from 'containers/ValidatedClaimsPage/constants';

const initialState = fromJS({
  assignedClaims: [],
  assignedClaimsCount: 0,
  steps: [],
});

const LawyerAssignedClaimsReducer = (
  state = initialState,
  action: AssignmentAction,
) => {
  switch (action.type) {
    case SET_LAWYER_ASSIGNED_CLAIMS:
      return state
        .set(
          'assignedClaims',
          fromJS(get(action.assignment, ['response', 'assignedClaims'], [])),
        )
        .set(
          'assignedClaimsCount',
          fromJS(
            get(action.assignment, ['response', 'assignedClaimsCount'], 0),
          ),
        );
    case SET_SEARCH:
      return state
        .set('assignedClaims', fromJS(action.data))
        .set('assignedClaimsCount', fromJS(get(action, 'data', []).length));
    case SET_LEGAL_PROCEEDINGS_STEPS:
      return state.set('steps', fromJS(get(action, 'steps', [])));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default LawyerAssignedClaimsReducer;
